import React, { useEffect, useState } from 'react';
import { Project } from './../interfaces/prof/ProjectInterface';
import { AlumniData } from '../interfaces/cglab/AlumniInterface';
import { Patent } from '../interfaces/prof/PatentInterface';

import InternationalJournal from '../components/InternationalJournal';
import InternationalConference from '../components/InternationalConference';
import DomesticJournal from '../components/DomesticJournal';
import DomesticConference from '../components/DomesticConference';
import PatentList from '../components/Patent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Container, Grid, Card, CardContent } from '@mui/material';



interface MainProps {
    page: string;
}

const API_BASE_URL = 'http://220.69.209.170:3333';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const MainSection: React.FC<MainProps> = (props) => {

    /* project */
    const [doingProjects, setDoingProjects] = useState<Project[]>([]);
    const [doneProjects, setDoneProjects] = useState<Project[]>([]);

    /* alumni */
    const [alumniData, setAlumniData] = useState<AlumniData[]>([]);

    /* publications */
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const fetchAPI = async (endpoint: string, setter: React.Dispatch<React.SetStateAction<any[]>>) => {
        try {
            const response = await fetch(`${API_BASE_URL}${endpoint}`);
            const data = await response.json();
            setter(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (props.page === "projects") {
            fetchAPI('/projects/getProjectDoingData', setDoingProjects);
            fetchAPI('/projects/getProjectDoneData', setDoneProjects);
        } else if (props.page === "alumni") {
            fetchAPI('/member/getAlumniMemberList', setAlumniData);
        }
    }, [props.page]);



    const renderMain = () => (
        <div id="banner-wrapper">
            <div className="container">
                <div className="row gtr-200">
                    <div>
                        <h3>직접 사용해보는 다이나믹 시뮬레이션 시뮬레이터</h3>
                    </div>
                </div>
                <iframe src="https://nakjun.github.io/" title="Dynamic Simulator"></iframe>
            </div>
        </div>
    );

    const maskingName = function (strName: string) {
        if (strName.length > 2) {
            var originName = strName.split('');
            originName.forEach(function (name, i) {
                if (i === 0 || i === originName.length - 1) return;
                originName[i] = '*';
            });
            var joinName = originName.join();
            return joinName.replace(/,/g, '');
        } else {
            var pattern = /.$/; // 정규식
            return strName.replace(pattern, '*');
        }
    };

    interface AlumniGroups {
        박사: AlumniData[];
        석사: AlumniData[];
        학사: AlumniData[];
    }

    const renderAlumni = () => {
        const groups: AlumniGroups = {
            박사: [],
            석사: [],
            학사: []
        };

        // 데이터를 그룹에 할당
        alumniData.forEach((alumni: AlumniData) => {
            if (alumni.degree.includes("박사") || alumni.degree.includes("석박통합")) {
                groups['박사'].push(alumni);
            } else if (alumni.degree.includes("석사")) {
                groups['석사'].push(alumni);
            } else if (alumni.degree.includes("학사")) {
                groups['학사'].push(alumni);
            }
        });

        return (
            <div className="container">
                <Container>
                    {Object.entries(groups).map(([groupTitle, alumniList]: [string, AlumniData[]], index: number) => (
                        <div key={index}>
                            <Typography variant="h4" gutterBottom style={{
                                fontWeight: 'normal', // 글꼴 굵기
                                fontFamily: 'KoPub Dotum, sans-serif', // 글꼴 'pretendard' 지정
                                color: '#44444', // 글꼴 색상
                                background: 'none',
                                padding: '15px 20px', // 패딩
                                margin: '15px 0', // 마진
                                display: 'inline-block', // 인라인 블록으로 설정하여 패딩이 적용되도록
                                borderBottom: '2px solid #444444', // 하단 테두리 선으로 선 그리기

                            }}>
                                {groupTitle} 졸업생
                            </Typography>
                            <Grid container spacing={2} justifyContent="space-between">
                                {alumniList.map((alumni: AlumniData, idx: number) => (
                                    <Grid item key={idx} style={{ width: '48%' }}>
                                        <Card sx={{ maxWidth: '100%' }}>
                                            <CardContent>
                                                <Typography variant="h5" component="div">
                                                    {alumni.name} ({alumni.student_id.toString().slice(0, 4)})
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    소속 : {alumni.company_name} / {alumni.position} <br />
                                                    업무 : {alumni.job_description}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    ))}
                </Container>
            </div>
        );

    };



    // const renderAlumni = () => (

    //     const phdAlumni = alumniData.filter(alumni => alumni.degree.includes("박사"));
    //     const otherAlumni = alumniData.filter(alumni => !alumni.degree.includes("박사"));

    //     <div className="container">


    //         <h3>졸업생 현황</h3>
    //         <Container>
    //             <Grid container spacing={2} justifyContent="space-between">
    //                 {alumniData.map((data, index) => (
    //                     <Grid item key={index} style={{ width: '48%' }}>
    //                         <Card sx={{ maxWidth: '100%' }}>
    //                             <CardContent>
    //                                 <Typography variant="h5" component="div">
    //                                     {data.name}({data.student_id.toString().slice(0, 4)})
    //                                 </Typography>
    //                                 <Typography variant="body2" color="text.secondary">                                        
    //                                     소속 : {data.company_name} / {data.position} <br />
    //                                     업무 : {data.job_description}
    //                                 </Typography>
    //                             </CardContent>
    //                         </Card>
    //                     </Grid>
    //                 ))}
    //             </Grid>
    //         </Container>
    //     </div>
    // );

    const renderProjects = () => (
        <div className="container">
            <h3>진행 중 프로젝트</h3>
            <Container className="container">
                <TableContainer component={Paper} className="tableContainer">
                    <Table aria-label="simple table">
                        <TableHead className="tableHead">
                            <TableRow>
                                <TableCell className="tableHeadCell" style={{ fontWeight: 'bold' }}>No</TableCell>
                                <TableCell className="tableHeadCell" style={{ fontWeight: 'bold' }}>Title</TableCell>
                                <TableCell className="tableHeadCell" style={{ fontWeight: 'bold' }}>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {doingProjects.map((project, index) => (
                                <TableRow key={project.no} className="tableBodyRow">
                                    <TableCell className="tableBodyCell">{index + 1}</TableCell>
                                    <TableCell className="tableBodyCell projectTitle">{project.title}</TableCell>
                                    <TableCell className="tableBodyCell">{project.date}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <h3>완료 프로젝트</h3>
                <TableContainer component={Paper} className="tableContainer">
                    <Table aria-label="simple table">
                        <TableHead className="tableHead">
                            <TableRow>
                                <TableCell className="tableHeadCell" style={{ fontWeight: 'bold' }}>No</TableCell>
                                <TableCell className="tableHeadCell" style={{ fontWeight: 'bold' }}>Title</TableCell>
                                <TableCell className="tableHeadCell" style={{ fontWeight: 'bold' }}>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {doneProjects.map((project, index) => (
                                <TableRow key={project.no} className="tableBodyRow">
                                    <TableCell className="tableBodyCell">{index + 1}</TableCell>
                                    <TableCell className="tableBodyCell projectTitle">{project.title}</TableCell>
                                    <TableCell className="tableBodyCell">{project.date}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </div>
    );

    const matches = useMediaQuery('(min-width:980px)');

    const renderPublications = () => (

        <div className="container">
            <h3>Publications</h3>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        variant={matches ? "standard" : "scrollable"}
                        centered={matches}
                        allowScrollButtonsMobile={!matches}
                        scrollButtons={!matches ? "auto" : false}
                    >
                        <Tab label="INTERNATIONAL JOURNAL" />
                        <Tab label="INTERNATIONAL CONFERENCE" />
                        <Tab label="DOMESTIC JOURNAL" />
                        <Tab label="DOMESTIC CONFERENCE" />
                        <Tab label="PATENT" />
                        {/* 추가 탭이 필요하면 여기에 */}
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <InternationalJournal />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <InternationalConference />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <DomesticJournal />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <DomesticConference />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <PatentList />
                </TabPanel>
                {/* 추가 탭 패널이 필요하면 여기에 */}
            </Box>
        </div>
    );

    switch (props.page) {
        case "main":
            return renderMain();
        case "projects":
            return renderProjects();
        case "publications":
            return renderPublications();
        case "alumni":
            return renderAlumni();
        default:
            return <div>Unknown page</div>;
    }
};

export default MainSection;
